import React, { useRef, useState } from 'react';
import { IconButton, TextField, useTheme } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ReactComponent as CalendarIcon } from '../../assets/icons/calendar.svg';
import { useAtom } from 'jotai';
import { selectedThemeState } from '../../state/UIState';
import { THEME } from '../../types';

interface MonthPickerProps {
  selectedMonth: number;
  selectedYear: number;
  onMonthChange: (month: number, year: number) => void;
  maxDate?: Date;
}

const MonthPicker: React.FC<MonthPickerProps> = ({
  selectedMonth,
  selectedYear,
  onMonthChange,
  maxDate,
}) => {
  const { colors } = useTheme();
  const [open, setOpen] = useState(false);
  const iconButtonRef = useRef<HTMLButtonElement>(null);
  const [selectedTheme] = useAtom(selectedThemeState);

  const value = new Date(selectedYear, selectedMonth - 1);

  const handleChange = (date: Date | null) => {
    if (date) {
      onMonthChange(date.getMonth() + 1, date.getFullYear());
    }
    setOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <IconButton
        ref={iconButtonRef}
        onClick={() => setOpen(true)}
        sx={{
          svg: { path: { fill: colors.icon.accent } },
          border: `1px solid ${colors.border.default}`,
          borderRadius: '4px',
        }}
      >
        <CalendarIcon style={{ transform: 'scale(1.2)' }} />
      </IconButton>
      <DatePicker
        open={open}
        onClose={() => setOpen(false)}
        value={value}
        onChange={handleChange}
        views={['year', 'month']}
        openTo='month'
        PopperProps={{
          anchorEl: iconButtonRef.current,
          className: `custom-datepicker-popup custom-datepicker-popup-${
            selectedTheme === THEME.DARK ? selectedTheme : THEME.LIGHT
          }`,
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            style={{ display: 'none' }} // Sakrivamo input polje
          />
        )}
        maxDate={maxDate}
      />
    </LocalizationProvider>
  );
};

export default MonthPicker;
